import {
    get,
    post,
    put,
    del 
  } from '../configApi'
  export async function loadGradeList() {
    return await get(`/grade/list/admin`)
  }
  export async function loadGradeListBy(params) {
    return await get(`/grade/list/admin`,params)
  }
  export async function insertGrade(body) {
    return await post(`/grade/manage/insert`,body)
  }
  export async function updateGrade(body) {
    return await put(`/grade/manage/update`,body)
  }
  export async function updateActive(body) {
    return await put(`/grade/manage/active`,body)
  }
  export async function deleteGrade(body) {
    return await del(`/grade/manage/delete`, body)
  }
  export async function getGradeListBin(body) {
    return await get(`/grade/list/adminbin`, body)
  }
  